import React, { useEffect, useRef, useState } from "react";
import AIChatbotSettingsTab from "./AIChatbotSettingsTab";

interface Props {
  selectedTab: string;
  aiConfigId: string;
}

export default function AIChatbotSettingsTabs(props: Props) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [stickyOffset, setStickyOffset] = useState(0);

  useEffect(() => {
    let resizeObserver: ResizeObserver | undefined;

    const calculateOffset = () => {
      const container = containerRef.current;
      if (!container) {
        return;
      }

      const parent = container.parentElement;
      const stickyHeader = parent?.previousElementSibling as HTMLElement | null;

      if (!stickyHeader) {
        setStickyOffset(0);
        return;
      }

      const styles = window.getComputedStyle(stickyHeader);
      const marginBottom = parseFloat(styles.marginBottom || "0");
      const nextOffset = Math.ceil(stickyHeader.getBoundingClientRect().height + marginBottom);

      setStickyOffset((prev) => (prev !== nextOffset ? nextOffset : prev));
    };

    const handleScroll = () => {
      window.requestAnimationFrame(calculateOffset);
    };

    calculateOffset();
    window.addEventListener("resize", calculateOffset);
    window.addEventListener("scroll", handleScroll, true);

    const container = containerRef.current;
    const parent = container?.parentElement;
    const stickyHeader = parent?.previousElementSibling as HTMLElement | null;

    if (stickyHeader && "ResizeObserver" in window) {
      resizeObserver = new ResizeObserver(() => calculateOffset());
      resizeObserver.observe(stickyHeader);
    }

    return () => {
      window.removeEventListener("resize", calculateOffset);
      window.removeEventListener("scroll", handleScroll, true);
      resizeObserver?.disconnect();
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="top-9 sticky z-40 w-full bg-slate-gray-50"
      style={{ top: stickyOffset ? `${stickyOffset}px` : undefined }}
    >
      <div className="flex justify-center border-b-2 border-slate-200 w-full">
        <AIChatbotSettingsTab
          title="General"
          route={`/ai/settings/general/${props.aiConfigId}`}
          selected={props.selectedTab === "General"}
        />
        {/* <AIChatbotSettingsTab
        title="Training"
        route={`/ai/settings/training/${props.aiConfigId}`}
        selected={props.selectedTab === "Training"}
      /> */}
        <AIChatbotSettingsTab
          title="Handoff"
          route={`/ai/settings/handoff/${props.aiConfigId}`}
          selected={props.selectedTab === "Handoff"}
        />
        <AIChatbotSettingsTab
          title="Playground"
          route={`/ai/settings/playground/${props.aiConfigId}`}
          selected={props.selectedTab === "Playground"}
        />
        {/* <AIChatbotSettingsTab
        title="Collect Data"
        route={`/ai/settings/data/${props.aiConfigId}`}
        selected={props.selectedTab === "Collect Data"}
      />
      <AIChatbotSettingsTab
        title="Starter Questions"
        route={`/ai/settings/questions/${props.aiConfigId}`}
        selected={props.selectedTab === "Starter Questions"}
      /> */}
        <AIChatbotSettingsTab
          title="Knowledge Overrides"
          route={`/ai/settings/knowledge-overrides/${props.aiConfigId}`}
          selected={props.selectedTab === "Knowledge Overrides"}
        />
        <AIChatbotSettingsTab
          title="Test"
          route={`/ai/settings/test/${props.aiConfigId}`}
          selected={props.selectedTab === "Test"}
        />
      </div>
      <div className="h-4" aria-hidden="true" />
    </div>
  );
}
